module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "dedi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("For Nate, aka Hot Cop")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "ded1"
  }, [_vm._v("Thank you for being so patient with"), _c('br'), _vm._v("my nearly constant state of “deadline dementia,”"), _c('br'), _vm._v("which is occasionally broken by the famed "), _c('br'), _vm._v("“pre-release jitters,” closely followed by "), _c('br'), _vm._v("a (very short) period of “book release euphoria.”")]), _vm._v(" "), _c('p', {
    staticClass: "deda"
  }, [_vm._v("You make my soul grin.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d39b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 66
// module chunks = 0